import Component from '@glimmer/component';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetDetails from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/tab-smart-compset-details';
import HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebar from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/tab-smart-compset-sidebar';
import type { BeniSmartCompset } from 'lumen/models';

interface HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSignature {
  Args: {
    isLoading: boolean;
    smartCompset: BeniSmartCompset | null;
  };
}

export default class HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompset extends Component<HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSignature> {
  get smartCompsets(): BeniSmartCompset[] {
    return this.args.smartCompset ? [this.args.smartCompset] : [];
  }

  <template>
    <div class="tab-smart-compset">
      {{#if @isLoading}}
        <PrismLoadingBar />
      {{/if}}

      <HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetSidebar
        @smartCompsets={{this.smartCompsets}}
      />

      {{#if @smartCompset}}
        <HotelBenchmarkInsightCompetitorsSmartCompsetTabSmartCompsetDetails
          @smartCompset={{@smartCompset}}
        />
      {{/if}}
    </div>
  </template>
}
